/**
 * The media types currently supported by the Vista CDN.
 */
export var VistaMediaType;
(function (VistaMediaType) {
    /**
     * An icon image for a Film/Session Attribute. For example: IMAX.
     */
    VistaMediaType["AttributeIcon"] = "AttributeIconGraphic";
    /**
     * An advertising image for a Film/Session Attribute.
     */
    VistaMediaType["AttributeAdvertisement"] = "AttributeAdvertising";
    /**
     * An image for an Advertising Profile.
     */
    VistaMediaType["AdvertisingProfileImage"] = "AdvertisingProfileItem";
    /**
     * A video for an Advertising Profile.
     */
    VistaMediaType["AdvertisingProfileVideo"] = "AdvertisingProfileVideo";
    /**
     * A gallery of images for a Site.
     */
    VistaMediaType["SiteGallery"] = "CinemaGallery";
    /**
     * An image for a Site.
     */
    VistaMediaType["SiteImage"] = "CinemaGraphic";
    /**
     * An image for a Corporate Booking.
     */
    VistaMediaType["CorporateBookingImage"] = "CorporateBookingImage";
    /**
     * A gallery of images for an Event.
     */
    VistaMediaType["EventGallery"] = "EventGallery";
    /**
     * A poster image for an Event.
     */
    VistaMediaType["EventPoster"] = "EventPosterGraphic";
    /**
     * An advertising image for a Film.
     */
    VistaMediaType["FilmAdvertisement"] = "FilmAdvertising";
    /**
     * A banner image for a Film.
     */
    VistaMediaType["FilmBackdrop"] = "FilmBackdrop";
    /**
     * An animated poster video for a Film.
     */
    VistaMediaType["FilmMotionPoster"] = "FilmMotionPoster";
    /**
     * A poster image for a Film.
     */
    VistaMediaType["FilmPoster"] = "FilmPosterGraphic";
    /**
     * A still image taken from a Film.
     */
    VistaMediaType["FilmStill"] = "FilmStill";
    /**
     * An image of a stylised Film title.
     */
    VistaMediaType["FilmTitleTreatment"] = "FilmTitleGraphic";
    /**
     * A full-length trailer for a Film.
     */
    VistaMediaType["FilmTrailer"] = "FilmTrailerFull";
    /**
     * A short/teaser trailer for a Film.
     */
    VistaMediaType["FilmShortTrailer"] = "FilmTrailerShort";
    /**
     * An image for an Item.
     */
    VistaMediaType["ItemImage"] = "ItemGraphic";
    /**
     * An advertising image for an Item.
     */
    VistaMediaType["ItemAdvertisement"] = "ItemAdvertising";
    /**
     * An image for a Promotion or Deal.
     */
    VistaMediaType["PromotionImage"] = "PromotionGraphic";
    /**
     * An advertising image for a Promotion or Deal.
     */
    VistaMediaType["PromotionAdvertisement"] = "PromotionAdvertising";
    /**
     * An icon for a Censor Rating. For example: R16.
     */
    VistaMediaType["CensorRatingIcon"] = "RatingIconGraphic";
    /**
     * An image for a Ticket Type.
     */
    VistaMediaType["TicketTypeImage"] = "TicketTypeGraphic";
    /**
     * An image for a Loyalty Club.
     */
    VistaMediaType["LoyaltyClubImage"] = "LoyaltyClubs";
    /**
     * A banner image of a Loyalty Club.
     */
    VistaMediaType["LoyaltyClubBanner"] = "LoyaltyClubBanner";
    /**
     * A login image for a Loyalty Club.
     */
    VistaMediaType["LoyaltyClubLoginImage"] = "LoyaltyClubLogin";
    /**
     * A payment image for a Loyalty Club.
     */
    VistaMediaType["LoyaltyClubPaymentImage"] = "LoyaltyClubPayment";
    /**
     * A home banner image for a Loyalty Club.
     */
    VistaMediaType["LoyaltyClubHomeBanner"] = "LoyaltyClubHomeBanner";
    /**
     * A header image for a Loyalty Club.
     */
    VistaMediaType["LoyaltyClubHeader"] = "LoyaltyClubHeader";
    /**
     * An image for a Loyalty Membership Program.
     */
    VistaMediaType["LoyaltyMembershipProgramImage"] = "LoyaltyMembershipPrograms";
    /**
     * An image for a Loyalty Reward Shop Item.
     */
    VistaMediaType["LoyaltyRewardShopItemImage"] = "LoyaltyRewardShopItems";
    /**
     * An image for a Loyalty Reward.
     */
    VistaMediaType["LoyaltyRewardImage"] = "LoyaltyReward";
    /**
     * A thumbnail for a Loyalty Reward.
     */
    VistaMediaType["LoyaltyRewardThumbnail"] = "LoyaltyRewardThumbnail";
    /**
     * An image for Loyalty Subscription Logo.
     */
    VistaMediaType["LoyaltySubscriptionLogo"] = "SubscriptionLogo";
    /**
     * An icon for a Web Payment Method.
     */
    VistaMediaType["WebPaymentMethodIcon"] = "WebPaymentMethodIcon";
})(VistaMediaType || (VistaMediaType = {}));
//# sourceMappingURL=media-type.js.map